const YOUTUBE_URL = 'https://www.youtube.com/watch?v=Gq87rP-NW5M';
const GUIDE_LINK = 'https://www.een.com/docs/app-notes/an039/';
const GATEWAY_GUIDE_LINK = 'https://www.een.com/docs/app-notes/an039/';

const DEFAULT_CAMERAS_COUNT_PER_ROW = 3;
const DEFAULT_ASPECT_RATIO = '16x9';
const DEFAULT_SHOW_TITLE = false;
const LAST_USED_APP = 'lastUsedWebApp';

enum WEB_INTERFACE {
  CLASSIC = 'classic',
  ENHANCED = 'enhanced',
}
const CLASSIC_WEB_APP_URL = 'http://login.eagleeyenetworks.com';
const BUSINESS_PORTAl_PROD_URL = 'https://businessportal.eagleeyenetworks.com';
const BUSINESS_PORTAl_TEST_URL = 'https://businessportal.test.eagleeyenetworks.com';

const ANALYTIC_EVENTS = {
  LOITER_DETECTION: 'een.loiterDetectionEvent.v1',
  OBJECT_INTRUSION: 'een.objectIntrusionEvent.v1',
  MOTION_DETECTION: 'een.motionDetectionEvent.v1',
  OBJECT_LINE_CROSS: 'een.objectLineCrossEvent.v1',
};

export {
  ANALYTIC_EVENTS,
  YOUTUBE_URL,
  GUIDE_LINK,
  GATEWAY_GUIDE_LINK,
  DEFAULT_CAMERAS_COUNT_PER_ROW,
  DEFAULT_ASPECT_RATIO,
  DEFAULT_SHOW_TITLE,
  WEB_INTERFACE,
  CLASSIC_WEB_APP_URL,
  LAST_USED_APP,
  BUSINESS_PORTAl_PROD_URL,
  BUSINESS_PORTAl_TEST_URL,
};

export const EMAIL_REGEX = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
export const ANALYTICS_ROI_SETTINGS = 'analyticsROISettings';
